<template>
  <div class="joined-template">
    <div class="game-overview-board" :class="isMasters ? 'masters-deco' : ''">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ isMasters: boolean }>(), { isMasters: false })
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import '~@npm/@gd/common-styles/dist/color-vars';
@import '../styles/vars';
.joined-template {
  position: relative;
}
.game-overview-board {
  box-shadow: 0 2em 0.5em -1.8em rgba(0, 0, 0, 0.35) inset, 0 -2em 0.5em -1.8em rgba(0, 0, 0, 0.35) inset;
  padding: @smallerspacing 0 @biggerspacing 0;
  margin-top: -0.9em;
}
.masters-deco {
  border-bottom: 3px solid;
  border-top: 3px solid;
  border-image: linear-gradient(to right, #71530d 0%, #f0eb9d 45%, #71530d 120%) 27;
  box-shadow: 0 2em 0.5em -1.8em rgba(0, 0, 0, 0.35) inset, 0 -2em 0.5em -1.8em rgba(0, 0, 0, 0.35) inset,
    0 0 1em rgba(0, 0, 0, 0.35);
}
.colorScheme.midGreen & {
  .game-overview-board {
    background: url(../assets/skat/skat_bg_pattern.jpg);
  }
  .masters-deco {
    background: url(../assets/skatmasters/skat_rays.png) center bottom no-repeat,
      url(../assets/skat/skat_bg_pattern.jpg);
  }
}
.colorScheme.red & {
  .game-overview-board {
    background: url(../assets/romme/romme_bg_pattern.jpg);
  }
}
</style>
